// extracted by mini-css-extract-plugin
export var container = "_35-0";
export var error = "_35-9";
export var label = "_35-5";
export var light = "_35-6";
export var md = "_35-3";
export var sm = "_35-2";
export var thin = "_35-8";
export var thinBold = "_35-7";
export var vertical = "_35-4";
export var xs = "_35-1";